export default {
  name: 'VejaTodos'
}
